export const REQUIRES_COMPANY_NAME_PROPS = [
  {
    cellClass: 'IDWE_transport_in_DLA24',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_1_nl_out',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'Transport_1_nl_in',
    propNames: ['transport_incoming_from_company_id']
  },
  {
    cellClass: 'Transport_1_plan_intern',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_1_plan_intern_outgoing',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'Transport_1_plan_extern',
    propNames: ['transport_incoming_from_company_id', 'buying_company'],
  },
  {
    cellClass: 'Transport_1_plan_extern_outgoing',
    propNames: ['transport_outgoing_from_company_id', 'transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'IDWE_transport_in_eu_expected_1',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'IDWE_transport_in_nl_expected',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'IDWE_transport_nl_combine',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'IDWE_transport_nl_individual',
    propNames: ['transport_individual_from_company_id', 'transport_individual_to_company_id'],
  },
  {
    cellClass: 'IDWE_transport_nl_out_combined',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'IDWE_transport_nl_out_expected',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'IDWE_transport_out_individual',
    propNames: ['transport_individual_from_company_id', 'transport_individual_to_company_id'],
  },
  {
    cellClass: 'Transport_eu_plan_intern',
    propNames: ['transport_incoming_from_company_id', 'buying_company'],
  },
  {
    cellClass: 'Transport_in_eu',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_1',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_2',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_3',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_4',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_5',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_6',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_7',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_8',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_9',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_planned_10',
    propNames: ['transport_incoming_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_1',
    propNames: ['transport_outgoing_from_company_id'],
  },{
    cellClass: 'Transport_out_eu_planned_2',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_3',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_4',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_5',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_6',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_7',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_8',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_9',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_out_eu_planned_10',
    propNames: ['transport_outgoing_from_company_id'],
  },
  {
    cellClass: 'Transport_plan_extern_incoming_eu',
    propNames: ['transport_incoming_from_company_id', 'buying_company'],
  },
  {
    cellClass: 'Transport_plan_extern_outgoing_eu',
    propNames: ['transport_outgoing_from_company_id', 'transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'Transport_plan_intern_outgoing',
    propNames: ['transport_outgoing_to_company_id'],
  },
  {
    cellClass: 'Transport_in_eu_intern',
    propNames: ['transport_incoming_from_company_id'],
  },
];
